<template>
    <v-card class="pa-2 ma-4">
        <v-alert
            text
            dense
            outlined
            prominent
            v-show="item.hasError"
            border="left"
            type="error"
            class="ma-4"
        >
            <v-row align="center">
                <v-col class="grow">
                    {{item.errorMessage || "An error has occurred."}}
                </v-col>
                <v-col class="shrink">
                    <v-btn
                        icon
                        color="pink"
                        @click="resetError(item)"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <ModalDialog :item="item"
         headline="Delete Item"
         message="This will delete the item from the Requisition Order. Would you like to continue?"
         :onAccept="deleteItem"
         :dialogProxy="deleteDialog" />
        <v-row class="pa-0 ma-0">
            <v-col class="mx-3 my-2 xs-6 sm-3 md-2 lg-2 xl-2  pa-0 ma-0">
                <v-text-field v-model.number="item.materialXId"
                              dense
                              label="Material ID:"
                              outlined
                              min="0"
                              type="number"
                              :rules="[rules.positiveInteger, rules.materialXid]"
                              class="inputQuantity"
                              @mousewheel.prevent=""
                              @wheel.prevent=""
                              @focus="$event.target.select()"
                              @change="materialUpdate(item)"
                              :disabled="item.isBusy || !canEdit || item.locationDepartmentId != $route.params.locationDepartmentId"
                              :error-messages="item.materialError"
                              v-on:keydown.tab.prevent>

                    <template slot="append">

                        <v-icon v-if="item.isFavorite" color="orange">mdi-star</v-icon>
                        <v-icon v-if="!item.isFavorite && !item.materialIsAdHoc" color="gray">mdi-star</v-icon>
                        <v-fade-transition leave-absolute>
                            <v-progress-circular v-if="item.materialIsBusy"
                                                 size="24"
                                                 color="info"
                                                 indeterminate></v-progress-circular>

                        </v-fade-transition>
                    </template>
                </v-text-field>

                <v-text-field v-model.number="item.quantity"
                              dense
                              label="Quantity"
                              outlined
                              min="0"
                              type="number"
                              :rules="[rules.positiveInteger]"
                              class="inputQuantity"
                              @focus="$event.target.select()"
                              @change="onQuantityChange(item)"
                              @mousewheel.prevent=""
                              @wheel.prevent=""
                              :disabled="item.isBusy || !canEdit || item.locationDepartmentId != $route.params.locationDepartmentId"
                              :error-messages="item.quantityError"
                              v-on:keydown.tab.prevent>

                    <template v-slot:append>

                        <v-fade-transition leave-absolute>
                            <v-progress-circular v-if="item.quantityIsBusy"
                                                 size="24"
                                                 color="info"
                                                 indeterminate></v-progress-circular>

                        </v-fade-transition>
                    </template>

                </v-text-field>

                <v-text-field v-model.number="item.materialDescription"
                              v-if="item.materialIsAdHoc"
                              dense
                              label="Ad Hoc Description"
                              outlined
                              @focus="$event.target.select()"
                              @change="adHocDescriptionUpdate(item)"
                              :disabled="item.isBusy || !canEdit"
                              :error-messages="item.adHocDescriptionError"
                              v-on:keydown.tab.prevent>

                    <template v-slot:append-outer>
                        <v-fade-transition leave-absolute>
                            <v-progress-circular v-if="item.adHocDescriptionIsBusy"
                                                 size="24"
                                                 color="info"
                                                 indeterminate></v-progress-circular>

                        </v-fade-transition>
                    </template>

                </v-text-field>
            </v-col>
            <v-col class="mx-3 my-2 xs-12 sm-6 md-4 lg-2 xl-2 pa-0 ma-0">
                <v-text-field v-model="item.notes"
                              label="Notes"
                              :disabled="!canEdit || item.locationDepartmentId != $route.params.locationDepartmentId"
                              @change="noteUpdate(item)"
                              :error-messages="item.noteError">

                    <template v-slot:append-outer>
                        <v-fade-transition leave-absolute>
                            <v-progress-circular v-if="item.noteIsBusy"
                                                 size="24"
                                                 color="info"
                                                 indeterminate></v-progress-circular>

                        </v-fade-transition>
                    </template>

                </v-text-field>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            icon
                            color="success"
                            v-on="on"
                            @click="undoChanges(item)"
                        >
                            <v-icon>mdi-undo</v-icon>
                        </v-btn>
                    </template>
                    <span>Undo changes</span>
                </v-tooltip>
            </v-col>

        </v-row>
        <v-row class="pa-0 ma-0">

            <v-col v-for="(itm, key) in item.attributes"
                   class="mx-6 my-2 xs-12 sm-6 md-4 lg-2 xl-2 pa-0 ma-0"
                   :key="key">


                <v-switch v-model="itm.isSelected"
                          class="ma-2"
                          v-bind:label="itm.attributeDescription"
                          @change="attributeUpdate(itm)"
                          v-bind:disabled="itm.isBusy || !canEdit || item.locationDepartmentId != $route.params.locationDepartmentId"
                          :error-messages="itm.errorMessage">

                    <template v-slot:label>
                        <v-chip class="ma-1"
                                small
                                v-bind:color="itm.color"
                                text-color="white">


                            <v-avatar center>
                                <v-icon small>{{itm.icon}}</v-icon>
                            </v-avatar>

                            {{itm.attributeDescription}}
                        </v-chip>
                    </template>
                </v-switch>

            </v-col>
        </v-row>


    </v-card>


</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import ModalDialog from '@/components/ModalDialog.vue';
    import axios from "axios";
    export default {
        name: 'RequisitionOrderItemForm',
        props: {
            item: {},
            requisitionOrder: {},
            onDelete: null
        },
        data() {
            return {
                originalValue: {},
                loading: false,
                deleteDialog: false,
                rules: {
                    positiveInteger: value => value >= 0 || 'Positive value required.',
                    materialXid: value => !!value || 'Material Id is required'
                },

            }
        },
        computed: {
            ...mapGetters(['getVrsUser', 'hasAccess']),
            canEdit() {
                return ((this.requisitionOrder.isOpen && (this.hasAccess('MATERIALRO'))) || (this.requisitionOrder.isProcessing && (this.hasAccess('PROCESSRO'))))
            }
        },
        components: {
            ModalDialog
        },
        mounted() {
            this.originalValue = Object.assign(this.originalValue, this.item);
        },
        methods: {
            ...mapActions(["sendMessage"]),
            showMessage(msg, success) {

                var successColor = 'success';

                if (!success) {
                    successColor = 'error'
                }

                this.sendMessage({
                    color: successColor,
                    text: msg,
                    timeout: 3000
                });
            },
            undoChanges(item) {
                if (item.materialXId != this.originalValue.materialXId) {
                    item.materialXId = this.originalValue.materialXId;
                    this.materialUpdate(this.item);
                }
                if (item.quantity != this.originalValue.quantity) {
                    item.quantity = this.originalValue.quantity;
                    this.quantityUpdate(this.item);
                }
                if (item.notes != this.originalValue.notes) {
                    item.notes = this.originalValue.notes;
                    this.noteUpdate(this.item);
                }

                item.materialError = '';
                item.noteError = '';
                item.quantityError = '';
                item.hasError = false;
            },
            resetError(item) {
                item.materialError = '';
                item.noteError = '';
                item.quantityError = '';
                item.hasError = false;
            },
            deleteItem(item, accept) {
                if (accept) {
                    item.quantity = 0;
                    this.quantityUpdate(item);
                } else {
                    item.quantity = this.originalValue.quantity;
                }
                //Remember to reset this or the dialog won't see a change in the proxy value
                this.deleteDialog = false;
            },
            onQuantityChange(item) {
                if (!item.quantity) {
                    item.quantity = 0;
                }

                if (item.quantity < 0) {
                    return;
                }

                if (item.quantity == this.originalValue.quantity) {
                    return;
                }

                if (item.quantity == 0) {
                    this.deleteDialog = true;
                } else {
                    this.quantityUpdate(item);
                }

            },
            quantityUpdate(item) {

                item.quantityIsBusy = true;
                item.quantityError = '';
                item.errorMessage = '';
                this.apiRoItemPut(item, 'subtotal').then(result => {

                    if (item.hasError) {
                        item.quantityError = item.errorMessage;
                        item.quantity = this.originalValue.quantity;
                        item.quantityIsBusy = false;
                        return;
                    }


                    item.totalPrice = item.quantity * item.unitPrice;
                    item.attributes = this.originalValue.attributes;
                    item.materialXId = this.originalValue.materialXId;
                    item.quantityIsBusy = false;

                    if (item.quantity == 0) {
                        this.onDelete(item);
                    }

                });
            },
            materialUpdate(item) {

                item.materialIsBusy = true;
                item.materialError = '';

                this.apiRoItemPut(item, 'material')
                .then(result => {
                    if (result.hasError) {
                        item.materialError = result.errorMessage;
                        item.materialXId = this.originalValue.materialXId;
                        item.materialIsBusy = false;
                        return;
                    }

                    item.materialXId = result.materialXId;
                    item.materialId = result.materialId;
                    item.materialDescription = result.materialDescription;
                    item.materialAlias = result.materialAlias;
                    item.unitPrice = result.unitPrice;
                    item.materialName = result.materialName;
                    item.uomId = result.uomId;

                    item.totalPrice = item.unitPrice * item.quantity;

                    item.materialIsBusy = false;
                });
            },
            noteUpdate(item) {

                item.noteIsBusy = true;
                item.noteError = '';

                this.apiRoItemPut(item, 'note')
                .then(result => {
                    if (result.hasError) {
                        item.noteError = result.errorMessage;
                        item.notes = this.originalValue.notes;
                        item.noteIsBusy = false;
                        return;
                    }

                    item.noteIsBusy = false;

                    if (item.notes && item.notes.length > 0) {
                        item.hasNote = true;
                    } else {
                        item.hasNote = false;
                    }

                });
            },
            adHocDescriptionUpdate(item) {

                item.adHocDescriptionIsBusy = true;
                item.adHocDescription = '';
                

                this.apiRoItemPut(item, 'adhocdescription').then(result => {

                    if (result.hasError) {
                        item.adHocDescriptionError = result.errorMessage;
                    }

                    item.adHocDescriptionIsBusy = false;

                });
            },
            attributeUpdate(item) {

                item.isBusy = true;
                item.attributeError = '';
                item.materialXId = this.originalValue.materialXId;

                this.apiRoItemPut(item, 'attribute').then(result => {

                    if (result.hasError) {
                        item.errorMessage = result.errorMessage;
                    }

                    item.isBusy = false;
                    item.id = result.id;
                    item.isSelected = result.isSelected;

                });
            },
            async apiRoItemPut(item, route) {
                item.errorMessage = '';
                item.hasError = false;

                try{
                    let response = await axios.put(`/api/RequisitionOrder/${route}`,item);
                    return response.data;
                }
                catch (e) {
                    item.errorMessage = e.response.data.errorMessage;
                    item.hasError = true;
    
                    return item;
                }
            },

            async setFavorite(item, isFavorite) {
                this.loading = true;

                item.isFavorite = isFavorite;
                item.locationDepartmentId = this.$route.params.locationDepartmentId;

                try{
                    let response = await axios.post(`/api/MaterialFavorite/activeorderfavorite`,item);
                    return response.data;
                }
                catch (e) {
                    item.errorMessage = e.response.data.errorMessage;
                    item.hasError = true;

                    return item;
                }
            },
        }
    }
</script>
<style>
    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance: textfield;
    }
</style>
